<template>
  <v-form ref="addEditEventDetailsForm" v-model="isValid">
    <v-row dense class="px-3">
      <v-col cols="12" md="12" class="mb-4 pt-0">
        <div class="text-subtitle-1 font-weight-bold">Event details</div>
      </v-col>
      <v-col cols="12" md="12" class="pt-0">
        <div class="text-body-2 font-weight-medium">Event name</div>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          dense
          outlined
          placeholder="eg: Melbourne Start-up Annual Pitch Night"
          v-model="currentEvent.name"
          :rules="requiredRules"
        />
      </v-col>
      <v-col cols="12" md="12" class="pt-0">
        <v-row dense>
          <v-col cols="6" md="12" class="pt-0" v-if="!isTravelEvent">
            <div class="text-body-2 font-weight-medium">Timezone</div>
          </v-col>

          <v-col cols="12" md="6" class="py-0" v-if="!isTravelEvent">
            <v-autocomplete
              v-model="currentEvent.timezone"
              :items="timezoneItems"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" class="pt-0">
            <div class="text-body-2 font-weight-medium">
              {{isTravelEvent ||
                currentEvent.linkPrivacy == "Private" ? "Date" : "Date and Time"
              }}
            </div>
          </v-col>
          <v-col cols="12" md="12">
            <v-alert
              text
              width="50%"
              color="primary"
              dense
              v-if="isDateTimePickerReadOnly"
            >
              <div class="d-flex justif-center align-center">
                <v-icon color="primary" class="mr-2">mdi-alert-circle</v-icon>
                <div>{{ alertText }}</div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="6" class="py-0">
            <vc-date-picker
              v-model="range"
              :mode="dateTimePickerMode"
              is-range
              :minDate="minStartDate"
              @input="handleBlur"
              is-required
              :select-attribute="attribute"
              :drag-attribute="attribute"
              :input-debounce="20000"
              :popover="{ placement: 'top', visibility: 'click' }"
              :timezone="currentEvent.timezone"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <v-text-field
                  :value="getEventDateTime(inputValue)"
                  v-on="inputEvents.start"
                  outlined
                  dense
                  :disabled="isDateTimePickerReadOnly"
                  :readonly="true"
                  :rules="requiredRules"
                  validate-on-blur
                  @change.native="inputEvents.updateValue($event.target.value)"
                  :placeholder="
                    currentEvent.linkPrivacy == 'Private' || isTravelEvent
                      ? 'Select date'
                      : 'Select date and time'
                  "
                />
              </template>
            </vc-date-picker>
          </v-col>
          <!-- <v-col cols="12" md="6" class="my-0 py-0">
            <div v-if="currentEvent.startDateTime != null">
              {{ getEventActivationAndExpirationDateTime() }}
            </div>
          </v-col> -->
          <template v-if="!currentEvent.hasSubEvents">
          <div v-if="!isTravelEvent">
            <v-col
              class="pt-0"
              cols="6"
              md="12"
              v-if="
                currentEvent.type == 'online' || currentEvent.type == 'hybrid'
              "
            >
              <div class="text-body-2 font-weight-medium">Event join link</div>
            </v-col>
            <v-col
              class="py-0"
              cols="6"
              md="6"
              v-if="
                currentEvent.type == 'online' || currentEvent.type == 'hybrid'
              "
            >
              <v-text-field
                dense
                outlined
                placeholder="Zoom or Google Meet URL"
                v-model="currentEvent.joiningLink"
              />
            </v-col>
          </div>

            <v-col cols="6" md="12" class="pt-0" v-if="!isTravelEvent">
              <div class="text-body-2 font-weight-medium">
                Event agenda URL <span class="grey--text">(optional)</span>
              </div>
            </v-col>
            <v-col cols="6" md="6" class="py-0" v-if="!isTravelEvent">
              <v-text-field
                dense
                outlined
                placeholder="Add a URL to your event agenda"
                v-model="currentEvent.agendaURL"
              />
            </v-col>

          </template>

          <v-col cols="12" md="12" class="pt-0">
            <div class="text-body-2 font-weight-medium">
              URL to your event page
              <span class="grey--text">(optional)</span>
            </div>
          </v-col>
          <v-col cols="6" md="6" class="py-0">
            <v-text-field
              dense
              outlined
              v-model="currentEvent.eventPageURL"
              placeholder="Add a URL so attendees can access information about your event"
              hint="This URL will also be accessible when your event is promoted within the Pappyon newsfeed."
            />
          </v-col>

          <v-col
            class="pt-0"
            cols="12"
            md="12"
            v-if="
              currentEvent.type == 'in-person' || currentEvent.type == 'hybrid' || isTravelEvent
            "
          >
            <div class="text-body-2 font-weight-medium">Location</div>
          </v-col>
          <v-col
            class="py-0"
            cols="6"
            md="6"
            v-if="
              currentEvent.type == 'in-person' || currentEvent.type == 'hybrid' || isTravelEvent
            "
          >
            <v-text-field
              dense
              outlined
              placeholder="e.g. State Library Victoria, 328 Swanston St, Melbourne 3000"
              v-model="currentEvent.address"
            />
          </v-col>


          <!-- <v-col cols="6"> </v-col> -->
          <v-col cols="12" md="12" hidden>
            <v-row no-gutters>
              <v-col cols="6" class="d-flex align-center justify-space-between">
                <v-switch
                  :class="[
                    'mt-0 mb-2 text-body-2 font-weight-medium mc-checkbox d-inline',
                    ,
                    { 'cursor-disabled': isEditMode },
                  ]"
                  hide-details
                  v-model="currentEvent.hasAskOfferNote"
                  label="Allow attendees to add AskOffer and General Notes"
                  style="font-size: 14px !important"
                  :disabled="isEditMode"
                ></v-switch>

                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-5" size="22">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>
                    The AskOffer and General Notes sections allow attendees to
                    ask for assistance from fellow attendees and offer their
                    expertise in the field they specialize in, as well as add
                    any notes they would like to share. This option cannot be
                    changed after the link has been created.
                  </span>
                </v-tooltip>
              </v-col>

            </v-row>
          </v-col>
          <v-col class="pt-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">About this event</div>
          </v-col>
          <v-col class="py-0" cols="6" md="6">
            <v-textarea
              outlined
              placeholder="Description about this event"
              v-model="currentEvent.description"
            />
          </v-col>
          <v-col cols="12" md="12">
            <v-row no-gutters>
              <v-col cols="6" class="d-flex align-center justify-start">
                <v-switch
                  :class="[
                    'mt-0 mb-2 text-body-2 font-weight-medium mc-checkbox d-inline',
                    ,
                    { 'cursor-disabled': isEditMode },
                  ]"
                  hide-details
                  v-model="currentEvent.enableChatroom"
                  label="Enable chat room"
                  style="font-size: 14px !important"
                ></v-switch>

                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-5" size="22">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>
                    Enable chat room for all attendees attending the event.
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>

        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isEditMode: { type: Boolean, default: false },
    eventCategory: { type: String, default: "multiConnect" },
  },
  mounted() {
    this.$emit("validatePage", "AddEditEventDetails", this);
  },
  computed: {
    ...mapGetters(["currentEvent", "currentSubEvent"]),
    minStartDate() {
      return new Date().toISOString().slice(0, 10);
    },
    alertText() {
      let eventStatusSuffix =
        this.currentEvent.getStatus() == "Active" ? "is Active" : "has expired";
      let text =
        this.currentEvent.name +
        "'s date and time can't be edited because it " +
        eventStatusSuffix;

      return text;
    },
    dateTimePickerMode() {
      if (this.currentEvent.hasSubEvents || this.isTravelEvent) {
        return "date";
      } else return "dateTime";
    },
  },
  created() {
    if (
      (this.isEditMode && this.currentEvent.getStatus() == "Active") ||
      (this.isEditMode && this.currentEvent.getStatus() == "Past")
    )
      this.isDateTimePickerReadOnly = true;

    //Set the start and end date-time values
    this.range.start = this.currentEvent.startDateTime;
    this.range.end = this.currentEvent.endDateTime;

    //Get list of available time zones
    this.timezoneItems = Intl.supportedValuesOf("timeZone");

    //If user hasn't selected a timezone, set a default value based on browsers timezone
    if (!this.currentEvent.timezone) {
      this.currentEvent.timezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    if (this.currentEvent.eventCategory === 'travel') {
      this.isTravelEvent = true;
    }
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is requried"],
      timezoneItems: [],
      isTravelEvent: false,
      range: {
        start: "",
        end: "",
      },
      attribute: {
        highlight: {
          start: {
            style: {
              backgroundColor: "#F15E31", //primary
            },
            contentStyle: {
              color: "#ffffff", // color of the text
            },
          },
          base: {
            style: {
              backgroundColor: "#FEECE8", // tint
            },
          },
          end: {
            style: {
              backgroundColor: "#F15E31", // primary
            },
            contentStyle: {
              color: "#ffffff", // color of the text
            },
          },
        },
      },
      isValid: false,
      isDateTimePickerReadOnly: false,
      selectedEvent: {},
    };
  },
  watch: {
    "currentEvent.timezone": function () {
      this.getEventActivationAndExpirationDateTime();
    },
    // currentEvent: function (newValue) {
    //   console.log("value changed for current event");
    //   console.log("newValue: ", newValue);
    // },
  },
  methods: {
    handleBlur() {
      this.currentEvent.startDateTime = this.range.start;
      this.currentEvent.endDateTime = this.range.end;
      this.$refs.addEditEventDetailsForm.resetValidation();
    },
    getEventDateTime(inputValue) {
        if (inputValue.start != null && inputValue.end != null)
          return inputValue.start + " to " + inputValue.end;
        return "";
    },
    getEventActivationAndExpirationDateTime() {
      return (
        "EventConnect link will automatically activate on " +
        this.currentEvent.getFormattedEventActivationDateTime() +
        " and expire on " +
        this.currentEvent.getFormattedEventExpirationDateTime() +
        " (" +
        this.currentEvent.timezone +
        ")"
      );
    },
    validatePage() {
      return this.$refs.addEditEventDetailsForm.validate();
    },
  },
};
</script>

<style>
</style>